import { render, staticRenderFns } from "./ManageStudents.vue?vue&type=template&id=4b5bae1e&scoped=true&"
import script from "./ManageStudents.vue?vue&type=script&lang=js&"
export * from "./ManageStudents.vue?vue&type=script&lang=js&"
import style0 from "./ManageStudents.vue?vue&type=style&index=0&id=4b5bae1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5bae1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VContainer,VFlex,VLayout,VProgressCircular})
